import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ConfirmDialogTemplateComponent } from '@optsolservices/ngx-confirm-dialog';
import { BaseService } from 'src/app/core/services/base.service';
import { OiGroupDialogData, OiGroupProcessDialogComponent } from 'src/app/shared/oi-group-process-dialog/oi-group-process-dialog.component';

@Component({
  selector: 'app-pos-account-pay-with-money-equipment-dialog',
  templateUrl: './pos-account-pay-with-money-equipment-dialog.component.html',
  styleUrls: ['./pos-account-pay-with-money-equipment-dialog.component.scss']
})
export class PosAccountPayWithMoneyEquipmentDialogComponent implements OnInit {

  customer = null;
  // {
  //   customerCode: '',
  //   customerName: 0,
  //   custoemrBalance: 0,
  // };
  storeId: number;
  containerId: number;
  equipmentTypeCode: string;
  formValid: boolean = false;
  formValue: any;
  busy: boolean = false;

  constructor(
    public dialogRef: MatDialogRef<PosAccountPayWithMoneyEquipmentDialogComponent>,
    private baseService: BaseService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialog: MatDialog
  ) { }

  ngOnInit() {
    this.baseService.executeCommand<any>('portal_finance_money_to_account_dialog_config', this.data.data)
      .subscribe(response => {
        if (response.responseCode === 0) {
          this.customer = response.data;
        } else {
          this.dialogRef.close(false);
        }
      });
  }

  paymentChanged(event: {
    storeId: number;
    containerId: number;
    equipmentTypeCode: string;
    formValid: boolean;
    formValue: any;
  }) {
    this.storeId = event.storeId;
    this.containerId = event.containerId;
    this.equipmentTypeCode = event.equipmentTypeCode;
    this.formValid = event.formValid;
    this.formValue = event.formValue;
  }

  save() {


    if (this.formValue.amountTendered <= 0) {
      const dialogRef = this.dialog.open(ConfirmDialogTemplateComponent, {
        width: '450px',
        data: {
          title: 'Negative Payment Amount',
          text: `The amount to put on the customer account cannot be negative.`,
          confirmButtonText: 'OK',
          cancelButtonText: 'No',
          showConfirmButton: true,
          showCancelButton: false
        }
      });

    } else {
      this.busy = true;
      const payload = {
        customerCode: this.customer.customerCode,
        storeId: this.storeId,
        containerId: this.containerId,
        equipmentTypeCode: this.equipmentTypeCode,
        amountPaid: this.formValue.amountTendered,
        paymentData: this.formValue
      };

      const dialogData: OiGroupDialogData = {
        title: 'Paying Money into the Customer Account',
        function: 'portal_oi_group_payment_account_payment_from_money_equipment',
        postBody: payload
      };

      const ref = this.dialog.open(OiGroupProcessDialogComponent, {
        data: dialogData,
        width: '450px'
      });

      ref.afterClosed().subscribe(oiResult => {
        this.busy = false;
        if (oiResult.responseCode === 0 && oiResult.data && oiResult.data.groupProcessedSuccessfully === true) {
          this.dialogRef.close(true);
        }
      });
    }
  }

}
